export default __webpack_public_path__ + "static/TSD_Tagger_Graphs_Hero-34ccf0528ee5c5f00777d5a97965a606.png";